import { FormHelperText } from '@material-ui/core';
import { trackAnalyticsEvent } from '../../../constants/analyticsMeta';

export const SkipCaptcha = ({ classes, meta, setShowVerifyEmailPopup }) => {
  return (
    <FormHelperText className={classes.skipCaptcha}>
      Skip Captcha?{' '}
      <span style={{ whiteSpace: 'nowrap' }}>
        <span
          onKeyDown={(e) => {}}
          tabIndex={0}
          className={classes.skipCaptchaLink}
          role="button"
          onClick={() => {
            const tempMeta = meta || {};
            trackAnalyticsEvent({
              eventName: 'clicked on Create a Free Account',
              payload: {
                label: 'Create a Free Account',
                ...tempMeta,
              },
            });
            setShowVerifyEmailPopup(true);
          }}
          style={{ whiteSpace: 'nowrap' }}
        >
          Create a Free Account
        </span>{' '}
      </span>
    </FormHelperText>
  );
};
